// extracted by mini-css-extract-plugin
export default {"container":"app-loading_container__H+W0E"};